module.exports = __webpack_public_path__ + "img/invite-to-add-pictures.75c0a2d7.png";